"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("g", {
    clipPath: "url(#clip0_1231_21198)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.69327 10.2867C7.7823 10.3517 7.88969 10.3867 7.99994 10.3867C8.11018 10.3867 8.21757 10.3517 8.3066 10.2867L11.2666 7.99999C11.3334 7.96741 11.3922 7.92034 11.4385 7.86219C11.4848 7.80405 11.5176 7.73631 11.5345 7.66389C11.5514 7.59148 11.5518 7.51621 11.5359 7.44358C11.52 7.37095 11.4881 7.30279 11.4426 7.24404C11.397 7.1853 11.3389 7.13746 11.2725 7.10401C11.2061 7.07055 11.1331 7.05233 11.0587 7.05067C10.9844 7.049 10.9106 7.06393 10.8428 7.09438C10.775 7.12482 10.7148 7.17001 10.6666 7.22665L8.5066 8.87999V2.72665C8.5066 2.59405 8.45392 2.46687 8.36016 2.3731C8.26639 2.27933 8.13921 2.22665 8.0066 2.22665C7.87399 2.22665 7.74682 2.27933 7.65305 2.3731C7.55928 2.46687 7.5066 2.59405 7.5066 2.72665V8.87999L5.33327 7.22665C5.28511 7.17001 5.22492 7.12482 5.15708 7.09438C5.08925 7.06393 5.01548 7.049 4.94115 7.05067C4.86682 7.05233 4.79379 7.07055 4.72739 7.10401C4.66099 7.13746 4.60289 7.1853 4.55731 7.24404C4.51173 7.30279 4.47983 7.37095 4.46392 7.44358C4.44802 7.51621 4.44851 7.59148 4.46537 7.66389C4.48223 7.73631 4.51502 7.80405 4.56136 7.86219C4.60771 7.92034 4.66643 7.96741 4.73327 7.99999L7.69327 10.2867Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.2333 8.93999C14.1007 8.93999 13.9735 8.99267 13.8797 9.08643C13.7859 9.1802 13.7333 9.30738 13.7333 9.43999V11.94C13.7333 12.161 13.6455 12.373 13.4892 12.5292C13.3329 12.6855 13.1209 12.7733 12.8999 12.7733H3.09993C2.87892 12.7733 2.66696 12.6855 2.51068 12.5292C2.3544 12.373 2.2666 12.161 2.2666 11.94V9.43999C2.2666 9.30738 2.21392 9.1802 2.12015 9.08643C2.02639 8.99267 1.89921 8.93999 1.7666 8.93999C1.63399 8.93999 1.50682 8.99267 1.41305 9.08643C1.31928 9.1802 1.2666 9.30738 1.2666 9.43999V11.94C1.2666 12.4262 1.45976 12.8925 1.80357 13.2363C1.97381 13.4066 2.17592 13.5416 2.39835 13.6338C2.62078 13.7259 2.85918 13.7733 3.09993 13.7733H12.8999C13.3862 13.7733 13.8525 13.5802 14.1963 13.2363C14.5401 12.8925 14.7333 12.4262 14.7333 11.94V9.43999C14.7333 9.30738 14.6806 9.1802 14.5868 9.08643C14.4931 8.99267 14.3659 8.93999 14.2333 8.93999Z",
    fill: fill
  })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "clip0_1231_21198"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "16",
    height: "16",
    fill: "white"
  }))));
};

exports["default"] = _default;